import { Link } from 'react-router-dom';
import { usePageMetadata } from '../hooks/usePageMetadata';

export function Privacy() {
  usePageMetadata({
    title: 'Privacy Policy — PhotoFeeler AI',
    description: 'How PhotoFeeler AI handles your photos, data, and privacy. Photos are auto-deleted after 30 days.',
    canonicalPath: '/privacy',
  });

  return (
    <div className="pt-24 pb-20 max-w-2xl mx-auto px-5 sm:px-8 animate-fade-in">
      <Link to="/" className="text-xs font-sans text-ink-faint hover:text-rose transition-colors mb-6 inline-block">&larr; Home</Link>
      <h1 className="font-sans text-4xl text-ink mb-8" style={{ fontWeight: 600 }}>Privacy Policy</h1>
      <div className="prose-custom">
        <p><strong>Last updated:</strong> March 15, 2026</p>

        <h2>What we collect</h2>
        <p>When you create an account, we store your email address and a hashed password. When you upload a photo, we temporarily store the image to send it to our AI analysis models.</p>

        <h2>How photos are handled</h2>
        <p>Your photos are sent to three AI models (OpenAI GPT-4o, Google Gemini, Anthropic Claude) for analysis. Photos are stored in encrypted cloud storage and <strong>automatically deleted after 30 days</strong>. You can delete any analysis and its associated photo at any time from your dashboard.</p>

        <h2>What we don&apos;t do</h2>
        <ul>
          <li>We never share your photos with other users</li>
          <li>We never use your photos for training AI models</li>
          <li>We never sell your data to third parties</li>
          <li>We never display your photos publicly</li>
        </ul>

        <h2>AI model providers</h2>
        <p>Photos are processed by OpenAI, Google, and Anthropic APIs. Each provider has their own data handling policies. We send photos via encrypted API calls and do not grant these providers any rights to retain or use your images beyond the immediate analysis request.</p>

        <h2>Cookies</h2>
        <p>We use essential cookies for authentication (keeping you logged in). We do not use tracking cookies or third-party analytics at this time.</p>

        <h2>Data deletion</h2>
        <p>You can delete your account at any time from the Account page. This permanently removes your email, credits, analysis history, and any stored photos. There is no recovery after deletion.</p>

        <h2>Contact</h2>
        <p>Questions about privacy? Email <a href="mailto:hello@photofeeler.ai" className="text-rose hover:underline">hello@photofeeler.ai</a>.</p>
      </div>
    </div>
  );
}
